import { getLastElement } from "../../helperFunctions";

const ConversationReducer = (currentConversation, action) => {
  switch (action.type) {
    case "clearConversation":
      return [];
    case "appendMessage":
      if (!action.message || (!action.message.text && !action.message.options)) {
        return currentConversation;
      }
      return action.message.sender === "customer"
        ? appendCustomerMessage(currentConversation, action.message)
        : appendAgentMessage(currentConversation, action.message);
    case "appendTyping":
      return appendAgentMessage(currentConversation, { type: "typing" });
    case "removeTyping":
      return [...removeTyping(currentConversation)];
    case "appendPastMessages":
      return appendPastMessages(currentConversation, action.messages);
    default:
      throw new Error(`case ${action.type} is not handled in the conversationReducer`);
  }
};

/**
 * This will append the agent/bot message to the chat window.
 *
 * @param currentConversation
 * @param newMessage
 * @returns {*[]}
 */
const appendAgentMessage = (currentConversation, newMessage) => {
  let conversationWithoutTyping = removeTyping(currentConversation);
  return [...conversationWithoutTyping, newMessage];
};

const appendCustomerMessage = (currentConversation, newMessage) => {
  let conversationWithoutOptions = removeOptions(currentConversation);
  return [...conversationWithoutOptions, newMessage];
};

const removeTyping = currentConversation => {
  return removeLastMessageByType(currentConversation, "typing");
};

const removeOptions = currentConversation => {
  return removeLastMessageByType(currentConversation, "options");
};

const removeLastMessageByType = (conversation, type) => {
  let lastMessage = getLastElement(conversation);
  if (lastMessage && lastMessage.type === type) {
    conversation.pop();
  }
  return conversation;
};

const appendPastMessages = (conversation, pastMessages) => {
  pastMessages = pastMessages.reverse();
  pastMessages = pastMessages.map(pastMessage => ({
    ...pastMessage.message,
    sender: pastMessage.sender
  }));

  return [...pastMessages, ...conversation];
};

export default ConversationReducer;
